export const waterBodyName = [
    'Belton Lake',
    'Blanco River',
    'Brazos River',
    'Lake Buchanan',
    'Canyon Lake',
    'Colorado River',
    'Comal River',
    'Guadalupe River',
    'Inks Lake',
    'Lady Bird Lake',
    'Lake Austin',
    'Lake Bastrop',
    'Lake Georgetown',
    'Lake Lyndon B. Johnson',
    'Lake Marble Falls',
    'Lake Travis',
    'Llano River',
    'Pedernales River',
    'San Gabriel River',
    'San Marcos River',
    'San Saba River',
    'Stillhouse Hollow Lake',
    'Addicks Reservoir',
    'Alvarado Park Lake',
    'Amistad Reservoir',
    'Angelina River',
    'Aquilla Lake',
    'Aransas River',
    'Armand Bayou',
    'Arroyo Colorado',
    'Attoyac Bayou',
    'Austin Bayou',
    'Averhoff Reservoir',
    'Balmorhea Lake',
    'Barton Creek',
    'Bastrop Bayou',
    'Baylor Creek Reservoir',
    'Bedias Creek',
    'Beech Creek',
    'Benbrook Lake',
    'Big Cow Creek',
    'Big Creek Reservoir',
    'Big Cypress Bayou',
    'Big Cypress Creek',
    'Big Lake',
    'Big Mineral Creek',
    'Big Pine Creek',
    'Big Sandy Creek',
    'Boerne City Lake',
    'Boggy Creek',
    "Bois D'Arc Creek",
    'Bonham City Lake',
    'Bonham State Park Lake',
    'Bosque River',
    'Brady Creek Reservoir',
    'Brandy Branch Reservoir',
    'Braunig Lake',
    'Buffalo Bayou',
    'Buffalo Creek Reservoir',
    'Buffalo Springs Reservoir',
    'Caddo Lake',
    'Calaveras Lake',
    'Canadian River',
    'Caney Creek (Red River tributary)',
    'Catfish Creek',
    'Cedar Bayou',
    'Cedar Creek Reservoir',
    'Chacon Creek',
    'Champion Creek Reservoir',
    'Choke Canyon Reservoir',
    'Cibolo Creek',
    'Clear Creek',
    'Coffee Mill Creek',
    'Coffee Mill Lake',
    'Coleto Creek',
    'Coleto Creek Reservoir',
    'Concho River',
    'Cooper Lake',
    'Davy Crockett Lake',
    'Dead Negro Draw',
    'Denton Creek',
    'Devils River',
    'Dickinson Bayou',
    'Double Bayou, East Fork',
    'E.V. Spence Reservoir',
    'Eagle Mountain Lake',
    'Fairfield Lake',
    'Falcon International Reservoir',
    'Fayette County Reservoir',
    'Fort Parker State Park Lake',
    'Fort Phantom Hill Lake',
    'Frio River',
    'Garcitas Creek',
    'Gibbons Creek Reservoir',
    'Granger Lake',
    'Grapevine Lake',
    'Green Lake',
    'Greenbelt Reservoir',
    'Hamrick Lake',
    'Highland Bayou',
    'Hords Creek Reservoir',
    'Houston County Lake',
    'Howell Lake',
    'Hubbard Creek Lake',
    'Imperial Reservoir',
    'James River',
    'Jim Chapman Lake',
    'Joe Pool Lake',
    'Keechi Creek',
    'Kirby Lake',
    'Lake Abilene',
    'Lake Alan Henry',
    'Lake Amon G. Carter',
    'Lake Anahuac',
    'Lake Arlington',
    'Lake Arrowhead',
    'Lake Athens',
    'Lake B. A. Steinhagen',
    'Lake Bardwell',
    'Lake Bellwood',
    'Lake Bob Sandlin',
    'Lake Brelsford',
    'Lake Bridgeport',
    'Lake Brownwood',
    'Lake Bryan',
    'Lake Bryson',
    'Lake Casa Blanca',
    'Lake Charlotte',
    'Lake Charlotte Creek (Lake Pass)',
    'Lake Cherokee',
    'Lake Childress',
    'Lake Cisco',
    'Lake Clyde',
    'Lake Coleman',
    'Lake Colorado City',
    'Lake Conroe',
    'Lake Corpus Christi',
    'Lake Creek Lake',
    'Lake Crook',
    'Lake Cypress Springs',
    'Lake Daniel',
    'Lake Diversion',
    'Lake Dunlap',
    'Lake Eanes',
    'Lake Eddleman',
    'Lake Findley',
    'Lake Fork',
    'Lake Fork Reservoir',
    'Lake Frankston',
    'Lake Fryer',
    'Lake Gilmer',
    'Lake Gladewater',
    'Lake Gonzales',
    'Lake Graham',
    'Lake Granbury',
    'Lake Halbert',
    'Lake Hawkins',
    'Lake Holbrook',
    'Lake Houston',
    'Lake J. B. Thomas',
    'Lake Jacksonville',
    'Lake Jane',
    'Lake Kemp',
    'Lake Kickapoo',
    'Lake Kurth',
    'Lake La Joya',
    'Lake Lavon',
    'Lake Leon',
    'Lake Limestone',
    'Lake Livingston',
    'Lake Marvin',
    'Lake McClellan',
    'Lake McQueeney',
    'Lake McSpadden',
    'Lake Meredith',
    'Lake Mexia',
    'Lake Mineral Wells',
    'Lake Monticello',
    'Lake Nacogdoches',
    'Lake Naconiche',
    'Lake Nasworthy',
    'Lake Nocona',
    "Lake O' the Pines",
    'Lake Palestine',
    'Lake Palo Pinto',
    'Lake Pat Cleburne',
    'Lake Pauline',
    'Lake Pflugerville',
    'Lake Pinkston',
    'Lake Placid',
    'Lake Plainview',
    'Lake Quitman',
    'Lake Randell',
    'Lake Raven',
    'Lake Ray Hubbard',
    'Lake Ray Roberts',
    'Lake Scarborough',
    'Lake Stamford',
    'Lake Striker',
    'Lake Sweetwater',
    'Lake Tampacuas',
    'Lake Tanglewood',
    'Lake Tawakoni',
    'Lake Texana',
    'Lake Texoma',
    'Lake Tyler',
    'Lake Tyler East',
    'Lake Waco',
    'Lake Walter E. Long',
    'Lake Waxahachie',
    'Lake Weatherford',
    'Lake Welsh',
    'Lake Whitney',
    'Lake Winnsboro',
    'Lake Wood',
    'Lake Worth',
    'Lampasas River',
    'Lavaca River',
    'Leon River',
    'Lewisville Lake',
    'Little Cypress Bayou',
    'Little River',
    'Lone Man Creek',
    'Lone Star Lake',
    'Lost Creek Reservoir',
    'Mackenzie Reservoir',
    'McGovern Lake',
    'Meadow Lake',
    'Medina Lake',
    'Medina River',
    'Millers Creek Reservoir',
    'Mitchell Lake',
    'Moss Lake',
    'Mountain Creek Lake',
    'Mud Lake',
    'Murphy Lake',
    'Navarro Mills Lake',
    'Navasota River',
    'Navidad River',
    'Neches River',
    'Negrohead Lake',
    'New Ballinger Lake',
    'Nolan River',
    'North Lake',
    'Nueces River',
    'O.C. Fisher Reservoir',
    'O.H. Ivie Lake',
    'Oak Creek Reservoir',
    'Onion Creek',
    'Oso Creek',
    'Other/Out of State',
    'Oyster Bayou',
    'Oyster Creek',
    'Palo Duro Reservoir',
    'Palo Pinto Creek',
    'Paluxy River',
    'Pat Mayse Lake',
    'Pease River',
    'Pecan Bayou',
    'Pecos River',
    'Pine Island Bayou',
    'Possum Kingdom Lake',
    'Prairie Dog Town Fork Red River',
    'Proctor Lake',
    'Purtis Creek State Park Lake',
    'Rainwater Creek',
    'Red Bluff Reservoir',
    'Red River',
    'Richland-Chambers Reservoir',
    'Rincon Bayou',
    'Rio Grande',
    'Rucker Pond',
    'Sabinal River',
    'Sabine Lake',
    'Sabine River',
    'Salado Creek',
    'Sam Rayburn Reservoir',
    'San Antonio River',
    'San Bernard River',
    'San Jacinto River',
    'Sanders Creek',
    'See Remarks',
    'Sheldon Reservoir',
    'Shoal Creek',
    'Smithers Lake',
    'Somerville Lake',
    'Spring Creek',
    'Squaw Creek Reservoir',
    'Sulphur River',
    'Sulphur Springs Lake',
    'Taylor Bayou',
    'Texas Highland Lakes',
    'Timpson Reservoir',
    'Toledo Bend Reservoir',
    'Tradinghouse Creek Reservoir',
    'Trinity River',
    'Turkey Creek',
    'Twin Buttes Reservoir',
    'Victor Braunig Lake',
    'Village Creek',
    'Walnut Branch',
    'White River',
    'White River Reservoir',
    'White Rock Lake',
    'Wichita Reservoir',
    'Wichita River',
    'Wright Patman Lake',
    'Zacate Creek'
];
export const lotFeatures = [
    'Agricultural',
    'Alley Access',
    'Back to Park/Greenbelt',
    'Back Yard',
    'On Golf Course',
    'Bluff',
    'City Lot',
    'Cleared',
    'Close to Clubhouse',
    'Corner Lot',
    'Cul-De-Sac',
    'Curbs',
    'Farm',
    'Few Trees',
    'Flag Lot',
    'Front Yard',
    'Garden',
    'Gentle Sloping',
    'Interior Lot',
    'Irregular Lot',
    'Landscaped',
    'Level',
    'Native Plants',
    'Near Golf Course',
    'Near Public Transit',
    'Open Lot',
    'Orchard(s)',
    'Pie Shaped Lot',
    'Private',
    'Private Maintained Road',
    'Public Maintained Road',
    'Road Maintenance Agreement',
    'Rock Outcropping',
    'Rolling Slope',
    'Sloped Down',
    'Sloped Up',
    'Split Possible',
    'Sprinkler - Automatic',
    'Sprinkler - Back Yard',
    'Sprinkler - Drip Only/Bubblers',
    'Sprinkler - In Front',
    'Sprinkler - In-ground',
    'Sprinkler - Manual',
    'Sprinkler - Partial',
    'Sprinkler - Rain Sensor',
    'Sprinkler - Side Yard',
    'Steep Slope',
    'Subdivided',
    'Trees-Heavy',
    'Trees-Large (Over 40 Ft)',
    'Trees-Many',
    'Trees-Medium (20 Ft - 40 Ft)',
    'Trees-Moderate',
    'Trees-Small (Under 20 Ft)',
    'Trees-Sparse',
    'Views',
    'Waterfall',
    'Wetlands',
    'Xeriscape',
    'Zero Lot Line',
    'None',
    'See Remarks'
];

export const parkingFeatures = [
    'Additional Parking',
    'Aggregate',
    'Alley Access',
    'Asphalt',
    'Assigned',
    'Attached',
    'Attached Carport',
    'Basement',
    'Boat',
    'Carport',
    'Circular Driveway',
    'Common',
    'Community Structure',
    'Concrete',
    'Converted Garage',
    'Covered',
    'Deck',
    'Deeded',
    'Detached',
    'Detached Carport',
    'Direct Access',
    'Door-Multi',
    'Door-Single',
    'Drive Through',
    'Driveway',
    'Elec Vehicle Charge Station(s)',
    'Electric Gate',
    'Enclosed',
    'Garage',
    'Garage Door Opener',
    'Garage Faces Front',
    'Garage Faces Rear',
    'Garage Faces Side',
    'Gated',
    'Golf Cart Garage',
    'Gravel',
    'Guest',
    'Heated Garage',
    'Inside Entrance',
    'Kitchen Level',
    'Leased',
    'Lighted',
    'Off Site',
    'Off Street',
    'Open',
    'Outside',
    'Oversized',
    'Parking Lot',
    'Parking Pad',
    'Parking Permit Required',
    'Paved',
    'Paver Block',
    'Private',
    'Reserved',
    'RV Access/Parking',
    'RV Carport',
    'RV Garage',
    'RV Gated',
    'Secured',
    'Shared Driveway',
    'Side By Side',
    'Storage',
    'Tandem',
    'Unassigned',
    'Underground',
    'Unpaved',
    'Valet',
    'Varies by Unit',
    'Workshop in Garage',
    'None',
    'See Remarks'
];
export const foundationDetails = [
    'Block',
    'Brick/Mortar',
    'Combination',
    'Concrete Perimeter',
    'Permanent',
    'Pillar/Post/Pier',
    'Raised',
    'Slab',
    'None',
    'See Remarks'
];
export const constructionMaterials = [
    'Adobe',
    'Asbestos',
    'Asphalt',
    'Block',
    'Brick',
    'Brick Veneer',
    'Cedar',
    'Clapboard',
    'Concrete',
    'Frame',
    'Glass',
    'HardiPlank Type',
    'ICAT Recessed Lighting',
    'Attic/Crawl Hatchway(s) Insulated',
    'Blown-In Insulation',
    'ICFs (Insulated Concrete Forms)',
    'Low VOC Insulation',
    'Recycled/Bio-Based Insulation',
    'Spray Foam Insulation',
    'Log',
    'Masonite',
    'Masonry-All Sides',
    'Masonry-Partial',
    'Natural Building',
    'Plaster',
    'Radiant Barrier',
    'Rammed Earth',
    'Siding-Aluminum',
    'Siding-Board & Batten',
    'Siding-Cement',
    'Siding-Metal',
    'Siding-Redwood',
    'Siding-Shake',
    'Siding-Vertical',
    'Siding-Vinyl',
    'Siding-Wood',
    'Stone',
    'Stone Veneer',
    'Straw',
    'Stucco',
    'Synthetic Stucco',
    'See Remarks',
    'None'
];
export const roof = [
    'Aluminum',
    'Asbestos Shingle',
    'Asphalt',
    'Bahama',
    'Barrel',
    'Bituthene',
    'Built-Up',
    'Composition',
    'Concrete',
    'Copper',
    'Elastomeric',
    'Fiberglass',
    'Flat Tile',
    'Foam',
    'Green Roof',
    'Mansard',
    'Membrane',
    'Metal',
    'Mixed',
    'Rolled/Hot Mop',
    'Rubber',
    'Shake',
    'Shingle',
    'Slate',
    'Spanish Tile',
    'Stone',
    'Synthetic',
    'Tar/Gravel',
    'Tile',
    'Wood',
    'None',
    'See Remarks'
];
export const unitStyle = [
    '1st Floor Entry',
    '2nd Floor Entry',
    '3rd+ Floor Entry',
    'Low Rise (1-3 Stories)',
    'Mid Rise (4-7 Stories)',
    'High Rise (8-13 Stories)',
    'Tower (14+ Stories)',
    'Single-level Floor Plan',
    'Elevator',
    'End Unit',
    'Entry Steps',
    'Middle Unit',
    'Loft',
    'Multi-level Floor Plan',
    'Neighbor Above',
    'Neighbor Below',
    'No Adjoining Neighbor',
    'Stilt Home',
    'See Remarks'
];

export const view = [
    'Bridge(s)',
    'Canal',
    'Canyon',
    'City',
    'City Lights',
    'Creek/Stream',
    'Downtown',
    'Garden',
    'Golf Course',
    'Hill Country',
    'Lake',
    'Marina',
    'Neighborhood',
    'Orchard',
    'Panoramic',
    'Park/Greenbelt',
    'Pasture',
    'Pond',
    'Pool',
    'River',
    'Rural',
    'Skyline',
    'Trees/Woods',
    'Vineyard',
    'Water',
    'None',
    'See Remarks'
];
export const flooring = [
    'Adobe',
    'Bamboo',
    'Brick',
    'Carpet',
    'Concrete',
    'Cork',
    'Laminate',
    'Linoleum',
    'Marble',
    'No Carpet',
    'Parquet',
    'Slate',
    'Stone',
    'Terrazzo',
    'Tile',
    'Vinyl',
    'Wood',
    'See Remarks'
];
export const restrictions = [
    'Adult 55+',
    'Adult 62+',
    'Building Size',
    'Building Style',
    'City Restrictions',
    'Covenant',
    'Deed Restrictions',
    'Development Type',
    'Easement',
    'Environmental',
    'Lease',
    'Limited # Vehicles',
    'Livestock',
    'Seller Imposed',
    'Zoning',
    'None',
    'See Remarks'
];

export const parkingFeeFrequency = ['Hourly', 'Daily', 'Weekly', 'Monthly', 'Yearly'];
